// Threshold → status derivations for the Ingestion page. Thresholds come from
// the spec's chart table (backend/docs/superpowers/specs/
// 2026-08-07-observability-metrics-design.md §named reports) — each chart
// carries its "act if" line so the page reads healthy/not-healthy at a glance.
export type Status = 'healthy' | 'warning' | 'critical' | 'unknown';

export const SLA_PENDING_WARN_HOURS = 6;

/** Oldest un-run DAILY_SLA chunk: >6h means yesterday's data is late. */
export function slaAgeStatus(hours: number | null): Status {
  if (hours === null) return 'healthy'; // nothing pending
  if (hours > SLA_PENDING_WARN_HOURS * 2) return 'critical';
  if (hours > SLA_PENDING_WARN_HOURS) return 'warning';
  return 'healthy';
}

/** Created vs completed over 24h: creating faster than completing = diverging. */
export function divergenceStatus(created: number, completed: number): Status {
  if (created <= completed) return 'healthy';
  return created > completed * 2 ? 'critical' : 'warning';
}

export function failedStatus(failedTotal: number): Status {
  return failedTotal > 0 ? 'warning' : 'healthy';
}

export function utilizationStatus(utilization: number): Status {
  if (utilization > 0.9) return 'critical';
  if (utilization > 0.7) return 'warning';
  return 'healthy';
}
